<template>
    <div id="app" class="d-flex flex-column h-100">
        <b-col v-if="isIE">
            <span>
                <h4>
                    Internet Explorer is no longer supported (
                    <a
                        href="https://www.microsoft.com/en-us/microsoft-365/windows/end-of-ie-support"
                        >https://www.microsoft.com/en-us/microsoft-365/windows/end-of-ie-support</a
                    >). <br />Please use Chrome,FireFox or Edge
                </h4>
            </span>
        </b-col>

        <b-col v-if="!isIE" id="appContent">
            <navHeader
                @initialized="setHeaderInitialized"
                @dailyManifestModalOpened="displayDailyManifestModal"
                @documentPackModalOpened="displayDocumentPackModal"
            />

            <loading :active.sync="isLoading" name="ajaxSpinner" />
            <router-view v-if="isHeaderInitialized" />
            <vue-progress-bar name="progress"></vue-progress-bar>
        </b-col>

        <dailyManifestModal ref="displayDailyManifestModal" :companyAccounts="getCompanyAccounts" />
        <documentPackModal ref="displayDocumentPackModal" :branches="getVisibleUserBranches" :carrier="'TNT'"/>
        

        <footerComponent />
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import dailyManifestModal from '@/components/dailyManifest';
import documentPackModal from '@/components/documentPack';
import navHeader from '@/components/nav-menu';
import footerComponent from '@/components/footer';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { yoyoHttp } from './services/http.service';
import { ACTIONS, MUTATIONS, CREATE_SHIPMENT_PREFIX, CORE_PREFIX } from '@/store/constants';
import store from '@/store';
export default {
    components: {
        navHeader,
        dailyManifestModal,
        documentPackModal,
        footerComponent,
        Loading
    },
    data() {
        return {
            showManifestModal: false,
            isHeaderInitialized: false
        };
    },
    watch: {
        $route(to, from) {
            document.title = to.meta.title;
        }
    },
    computed: {
        ...mapGetters('core', ['getCompanyAccounts', 'getUserData', 'getVisibleUserBranches']),

        isLoading() {
            return this.$store.state.core.loading;
        },
        isIE() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf('MSIE ');
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                // If Internet Explorer, return version number
                return true;
            }
            return false;
        }
    },
    methods: {
        displayDailyManifestModal() {
            this.$refs['displayDailyManifestModal'].showDailyManifestModal();
        },

        displayDocumentPackModal(carrier) {
            this.$refs['displayDocumentPackModal'].showDocumentPackModal(carrier);
        },

        setHeaderInitialized() {
            this.isHeaderInitialized = true;
        }
    },
    async mounted() {
        window.topProgress = this.$Progress;
        window.topProgress.finish();
    },
    async created() {
        //Use the unique name of app.{hash}.js as cachescope, to ensure that when we publish a new version, cached data is cleared
        yoyoHttp.registerCacheScope(document.currentScript.src);
    }
};
</script>
<style>
#app {
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}

.invalid-feedback {
    text-align: left;
}

.is-invalid {
    background-image: none !important;
    border: 1px solid #dc3545;
}

.invalid-fields {
    text-align: left;
    display: none;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
}

.validation-error {
    font-size: 80%;
    color: #dc3545;
    text-align: left !important;
}

#appContent {
    margin-bottom: 10px;
}

.headingRow {
    text-align: left;
    display: flex;
    flex-wrap: wrap;
}

/* This aligns every b-form-group in order to 
                    get labels aligned with checkboxes for example */
.form-row {
    align-items: center;
}
</style>
